document.addEventListener("DOMContentLoaded", function () {

  /* =========================
     MOBILE MENU TOGGLE
  ========================== */
  const menuToggle = document.getElementById("menu-toggle");
  const menuClose = document.getElementById("menu-close");
  const mobileMenu = document.querySelector(".mobile-custm-menu");

  if (menuToggle && menuClose && mobileMenu) {
    menuToggle.addEventListener("click", function () {
      mobileMenu.classList.add("open");
      menuToggle.style.display = "none";
      menuClose.style.display = "block";
    });

    menuClose.addEventListener("click", function () {
      mobileMenu.classList.remove("open");
      menuToggle.style.display = "block";
      menuClose.style.display = "none";
    });
  }

  /* =========================
     CHECKOUT BUTTON REDIRECT
  ========================== */
  const checkoutBtn = document.querySelector(".checkout_button_cstm");
  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", function () {
      setTimeout(function () {
        window.location.href = "/checkout";
      }, 3000);
    });
  }

  /* =========================
     VIDEO PLAY BUTTON ALT FIX
  ========================== */
  const videoWrapper = document.querySelector(".home-video-wrapper");
  if (!videoWrapper) return;

  const altText =
    videoWrapper.dataset.buttonAlt || "Play video";

  const observer = new MutationObserver(function () {
    const playImg = videoWrapper.querySelector(
      'img[src*="Group_2"]'
    );

    if (!playImg) return;

    if (!playImg.hasAttribute("alt") || playImg.alt === "") {
      playImg.setAttribute("alt", altText);
    }

    observer.disconnect();
  });

  observer.observe(videoWrapper, {
    childList: true,
    subtree: true
  });

});
